import * as apiUrl from "../Config/ApiUrl";

export default {
    data() {
        return {
            apiUrl
        }
    }
};
